import React from 'react';
import styles from './Tooltip.module.css';
import PropTypes from 'prop-types';

const Tooltip = ({ isVisible, heading ,subHeading}) => {
  if (!isVisible) {return null;}

  return (
    <div className={styles.tooltip}>
      <div className={styles.tooltipHeader}>{heading}</div>
      <div className={styles.tooltipText}>{subHeading}</div>
    </div>
  );
};

export default Tooltip;

Tooltip.propTypes = {
  isVisible: PropTypes.bool,
  heading: PropTypes.string,
  subHeading: PropTypes.string
};